/**
 * Strategy selection and registration
 */

import type { AudioExtractionStrategy, ExtractionStrategy } from '../types';
import { WebCodecsStrategy } from './webcodecs';
import { FFmpegStrategy } from './ffmpeg';
import { PassthroughStrategy } from './passthrough';

export interface SelectStrategyOptions {
  exclude?: ExtractionStrategy[];
}

/**
 * Select the best available extraction strategy for a file
 * Priority: WebCodecs > FFmpeg > Passthrough
 */
export async function selectStrategy(
  file: File,
  options?: SelectStrategyOptions
): Promise<AudioExtractionStrategy> {
  const strategies: AudioExtractionStrategy[] = [
    new WebCodecsStrategy(),
    new FFmpegStrategy(),
    new PassthroughStrategy(),
  ];

  for (const strategy of strategies) {
    // Skip excluded strategies
    if (options?.exclude?.includes(strategy.name)) {
      continue;
    }

    // Check if strategy supports current browser and can handle this file
    const supported = await strategy.checkSupport();
    if (supported && strategy.canHandle(file)) {
      return strategy;
    }
  }

  // Passthrough is always available as final fallback
  return new PassthroughStrategy();
}

// Export strategy classes for direct use if needed
export { WebCodecsStrategy, FFmpegStrategy, PassthroughStrategy };
